import { useStore } from "zustand";
import { appStore } from "../store";

export const useLanguages = () =>
  useStore(appStore, (state) => ({
    languages: state.languages,
    language: state.language,
  }));

export const useLanguagesActions = () =>
  useStore(appStore, (state) => ({
    getLanguagesOptions: state.getLanguagesOptions,
    setLanguages: state.setLanguages,
    setLanguage: state.setLanguage,
  }));
